/**
 * Logger Utility
 * Provides environment-aware logging with optional error tracking integration
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  /**
   * Log info messages (only in development)
   */
  info: (...args) => {
    if (isDevelopment) {
      console.log('[INFO]', ...args);
    }
  },

  /**
   * Log info messages (alias for info)
   */
  log: (...args) => {
    if (isDevelopment) {
      console.log('[INFO]', ...args);
    }
  },

  /**
   * Log error messages
   * In production, these should be sent to an error tracking service
   */
  error: (...args) => {
    if (isDevelopment) {
      console.error('[ERROR]', ...args);
    }
    // TODO: Integrate with error tracking service (e.g., Sentry) for production
    // if (!isDevelopment) {
    //   errorTrackingService.captureError(...args);
    // }
  },

  /**
   * Log warning messages
   */
  warn: (...args) => {
    if (isDevelopment) {
      console.warn('[WARN]', ...args);
    }
  },

  /**
   * Log debug messages (only in development)
   */
  debug: (...args) => {
    if (isDevelopment) {
      console.debug('[DEBUG]', ...args);
    }
  },

  /**
   * Log API requests/responses (only in development)
   */
  api: (method, url, data) => {
    if (isDevelopment) {
      console.log(`[API ${method.toUpperCase()}]`, url, data || '');
    }
  }
};

export default logger;

